import "bootstrap/dist/css/bootstrap.min.css";
import queryString from "query-string";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "reactjs-popup/dist/index.css";

import {
  ctaClickEvent,
  formAbandonmentEvent,
  formFieldErrorEvent,
  formIntermediateEvent,
  formStartEvent,
  formSubmissionFailEvent,
  formSuccessEvent,
} from "../services/adobeDataLayer.js";

import {
  callLSQLapp,
  DataLayerEvent,
  encryptBody,
  getEligibility,
  getLsqLeadBody,
  setValuesInLocalStorange,
} from "../services/lsq.js";

import { notifySuccess, notifyWarn, offersAlert } from "./Toastifyfn";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function Form() {
  const [personalShow, setPersonalShow] = useState(true);
  const [inputs, setInputs] = useState({});
  const [error, setErrors] = useState({});
  const [space, setSpace] = useState(false);
  const [spaceTwo, setSpaceTwo] = useState(false);
  const [checked, setChecked] = useState(true);

  const [mobileVal, setMobileval] = useState("");
  const [disableBtn, setDistablebtn] = useState(false);
  const [offers, setOffers] = useState({});

  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [otpsent, setOtpsent] = useState(false);
  const [token, setToken] = useState("");
  const [otpdisableBtn, setOtpBtn] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [PIN, setPIN] = useState("");
  const [cityName, setCityname] = useState("");
  const [citydefined, setCitydefined] = useState(false);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);

  const [modalShow, setModalShow] = React.useState(false);

  const [OTP, setOTP] = useState("");
  const [timerDisplay, setTimerDisplay] = useState("none");
  const [otpBtnText, setOtpBtnText] = useState("Resend");
  const [resendBtnDisplay, hideDisplayBtn] = useState("initial");
  const [timer, setTimer] = useState(0);
  const [otpDisabled, setOtpDisabled] = useState(false);

  const [eventFired, setEventFired] = useState({
    fullname: false,
    pan: false,
    email: false,
    mobile: false,
    otp: false,
    terms_chk: false,
    pincode: false,
    applyNow: false,
    homeLoanAmountRequired: false,
  });

  const hasTriggeredFormStart = useRef(false);
  let lastAccessedField = "na";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      //console.log("lead form started: ", hasTriggeredFormStart.current)
      // Custom logic to be executed before tab or window is closed
      if (hasTriggeredFormStart.current) {
        formAbandonmentEvent(
          "HL NCA lead form",
          "lead generation",
          lastAccessedField,
          "details",
        );
        //console.table(window.adobeDataLayer)
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    //Clean Up
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    [],
  );
  useEffect(() => {
    if (mobileVal.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, mobileVal, otpsent]);
  // set Fbp, Fbc, UTM parameters values
  useEffect(() => {
    localStorage.removeItem("userData");
    let fbpVal = cookies["_fbp"] === undefined ? "" : cookies["_fbp"];
    let fbcVal = cookies["_fbc"] === undefined ? "" : cookies["_fbc"];

    setFbp(fbpVal);
    setFbc(fbcVal);
  }, []);
  inputs.FBClickID = fbc;
  inputs.FBPixelID = fbp;

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        dialogClassName="modal-70w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            TERMS AND CONDITIONS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>DECLARATION</b> <br />
          I/We hereby confirm my/our interest in availing loan facility in the
          form of (i.e. Home Loan /Loan Against Property/Balance Transfer/Office
          Premises Loan/Top up)from ICICI Bank Limited (“ICICI Bank”) and in
          relation thereto I have applied for the loan facility by visiting the
          [www.icicibank.com] (“Website”) by submitting my application
          electronically.
          <br />
          <br />
          I/We hereby confirm that I/we have authorized the representative of
          ICICI Bank to enter the application details in the electronic
          application form on my/our behalf in accordance with the
          instructions/information given by me/us in the electronic application
          form."
          <br />
          <br />
          I/We have reviewed and verified the details entered by ICICI Bank’s
          representative in the electronic application form and declare the same
          to be true, correct and updated. I/We hereby confirm that and the
          electronic application form has been submitted by ICICI Bank’s
          representative post my/our review, verification and confirmation of
          the application details.",
          <br />
          <br />
          I/We confirm that the information submitted by me/us electronically
          and the details already available with ICICI Bank (if any) are true,
          correct, complete and up to date in all respects and that such
          information can be relied upon by ICICI Bank for the purpose of loan
          facility.
          <br />
          <br />
          I/we understand that the processing fee is a one-time non-refundable
          fee and is collected by ICICI Bank for the purpose of processing
          my/our loan facility request and such processing fee once paid, will
          not be refunded in any circumstances.
          <br />
          <br />
          I/We understand that the loan facility, if sanctioned, shall be
          subject to the customary terms and conditions as applicable to the
          product.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to collect information/personal data
          from me and other agencies including Unique Identification authority
          of India (UIDAI), Credit information companies (CICs), and conduct
          verification/due diligence, make references and enquiries with the
          group companies, that ICICI Bank may deem fit, for the purpose of the
          loan facility.
          <br />
          <br />
          I/We understand that sanction of loan is at the sole discretion of
          ICICI Bank. ICICI Bank reserves the right to reject the application
          without assigning any reason and shall not held liable for such
          rejection. With respect to pre-approved loan, if any, ICICI Bank
          reserves the right at any time to withdraw the loan offer and/ or
          modify, alter the pre- approved loan, terms and conditions and / or
          ask for any additional document /information from customer. The loan
          facility will only be established/disbursed upon completion of
          definitive loan documents and other terms and conditions as ICICI Bank
          may reasonably require.
          <br />
          <br />
          I/We understand that the disbursement of funds under the sanction
          letter accepted by me/us is subject to completion of legal and
          technical analysis of the property to be mortgaged, to the
          satisfaction of ICICI Bank, wherein the title to the property can be
          ascertained to be clear and marketable.
          <br />
          <br />
          I/We hereby confirm that the there are no insolvency proceeding
          initiated against me/us nor I/we has ever been adjudicated insolvent /
          bankrupt
          <br />
          <br />
          I/We undertake to inform ICICI Bank / its agents regarding the change
          in the residential addresses to provide any further information that
          ICICI Bank may require.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to exchange, share or part with all
          the information, data or document in relation to the loan application
          including but not limited to the credit repayment, history or default,
          if any, committed by the me/us to credit bureaus, agencies, statutory
          bodies, information utilities.
          <br />
          <br />
          Except to the extent disclosed to ICICI Bank herein, no Chairman /
          Managing Director or director or a relative/near relation of a
          Chairman / Managing Director or director of a banking company
          (including ICICI Bank and its subsidiaries) or mutual funds/venture
          capital funds or a relative/near relation of a senior officer of ICICI
          Bank, as specified by RBI, is: a partner of our concern, or a trustee,
          member, director, manager, employee of our concern, or of our
          subsidiary, or our holding company, or a guarantor on my/our behalf,
          or holds substantial interest in our concern or my/our subsidiary or
          holding company. For the purpose of this clause the terms “relative”,
          “near relation” & “senior officer” shall have the same meaning
          ascribed to them under the RBI master circular on Loans and Advances
          dated July 1, 2015, para 2.2.1.8 and shall include any amendments made
          thereto.
          <br />
          <br />
          I/We undertake to inform as to any change in my occupation/residential
          address. /mobile and to provide any further information/document that
          ICICI bank may require from time to time. In case of
          non-provision/non-updation of mobile number, I/We would not receive
          SMS alerts pertaining to the account and shall not hold ICICI Bank
          liable for the same.
          <br />
          <br />
          I/We acknowledge that ICICI Bank reserves the right to retain such
          documents submitted with this application and will not return the same
          to the me/us.
          <br />
          <br />
          I/We hereby declare and affirm that the I/we have not made any
          payments in cash.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to store all information/data
          provided herein including personal and business information with ICICI
          group companies/other institutions/ such other persons as may be
          necessary/ required for the purpose of, including but not limited to,
          marketing, cross selling of various products and services etc to
          me/us, use or process the aforesaid information/data by such person/s,
          or furnishing of the processed information/ data/ products thereof to
          other Banks/Institutions/other persons as may be necessary, and we
          shall not hold ICICI Bank liable in connection with the use of such
          information or otherwise.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to exchange, share or part with all
          information/data provided herein including personal and business
          information with ICICI group companies/other institutions/ such other
          persons as may be necessary/ required for the purpose of, including
          but not limited to, marketing, cross selling of various products and
          services etc to me/us, use or process the aforesaid information/data
          by such person/s, or furnishing of the processed
          information/data/products thereof to other Banks/Institutions/other
          persons as may be necessary, and we shall not hold ICICI Bank liable
          in connection with the use of such information or otherwise.
          <br />
          <br />
          I/We hereby declare that the information of GSTIN with respect to the
          number and billing address is correct and ICICI Bank can update the
          same in its records. I/We hereby declare that the information provided
          can be used by ICICI Bank for the purposes of charging GST and
          reporting of transactions on the GSTN portal and for other related
          aspects in relation to reporting as stated under GST Act and
          applicable rules in this regard.
          <br />
          <br />
          I/We may share, exchange or deliver instruction/information/document
          electronically to ICICI Bank through email. I/We acknowledge and
          understand that communication through e-mail cannot be guaranteed to
          be secured or error free and such information could be
          incomplete/unsafe and subject to tampering and unauthorized access and
          I/we shall not hold ICICI Bank responsible or liable for relying
          and/or acting on such instructions/document/information received
          through email.
          <br />
          <br />
          I/We hereby consent to receiving information from Central KYC Registry
          through SMS/Email on the registered number/email address
          <br />
          <br />
          I/We agree to receive update on various products and services related
          information and special offer from ICICI Bank/group companies and
          other entities via email alerts, or SMS alerts or phone call.
          <br />
          <br />
          <b>
            REVERSE SOLICITATION DECLARATIONS (APPLICABLE FOR NRI/OCI CUSTOMERS)
          </b>
          <br />
          <br />
          I/We hereby certify that I am/we are resident outside India who is/are
          either citizen of India or Person of Indian Origin (“Non-Resident
          Indian”) as defined under the Foreign Exchange Management Act, 1999 as
          amended, modified or updated from time to time.
          <br />
          <br />
          I/We confirm that I/we am/are interested in availing loan facility in
          the form of Home Loan /Loan Against Property/Balance Transfer/Office
          Premises Loan/Top up (“Facility”) from ICICI Bank Limited, India
          (“ICICI Bank”) and in this regard I/We hereby agree, acknowledge and
          confirm that:
          <br />
          <br />
          (a) I/we have voluntarily applied for the loan facility by visiting
          the [website]
          <br />
          <br />
          (b) The decision to avail the loan facility, through ICICI Bank’s
          website is my/our own independent decision, which has been considered
          after personal analysis and careful consideration of the risks,
          benefits, terms and conditions taking into account my/our investment
          objectives, financial situation and particular needs.
          <br />
          <br />
          (c) I/We hereby declare that ICICI Bank has not
          influenced/communicated/ solicited/ marketed about Facility and that
          I/we have sought the assistance of ICICI Bank without any liability
          for ICICI Bank. I/We shall not hold ICICI Bank liable or responsible
          in any manner whatsoever or make any claim against ICICI Bank or the
          regulators in Oman, Qatar, QFC, Singapore, UAE, DIFC, Bahrain or India
          in relation to the management or operations of the Facility.
          <br />
          <br />
          (d) There are/shall be no legal or regulatory prohibitions or
          impediments, as per the laws of my/our home country, against my/our
          maintaining my/our relationship with ICICI Bank, including availing
          the aforementioned Facility.
          <br />
          <br />
          (e) In availing the Facility, I/we shall ensure that I/we are in full
          compliance with all laws and regulations, including, without
          limitation, all applicable exchange control/taxation laws/regulations
          in my/our home/host country and I/ we am/ taking this decision based
          on my/ our analysis or legal counsel.
          <br />
          <br />
          (f) I/We shall obtain all necessary regulatory approvals, if required,
          in connection with availing the Facility and/ or entering into any
          such transactions and shall promptly make all necessary regulatory
          reporting, as and when required, to the relevant authorities in my/our
          home/host country or any other country of residence where I/we may
          relocate to in future and I/we agree to furnish to ICICI Bank, upon
          request, copies of the approvals/reports, if any
          <br />
          <br />
          (g) I/We are aware that the Facility availed by me/us may or may not
          be serviced by the offshore branches/representative
          offices/subsidiaries of ICICI Bank located outside India and shall
          further be subject to applicability of the applicable laws in such
          jurisdiction.
          <br />
          <br />
          (h) I/We shall indemnify and keep indemnified ICICI Bank, its
          affiliates, directors, representatives, employees and agents against
          any/ all direct, indirect, special, incidental or consequential
          losses, costs, expenses, suits, damages, whatsoever, which ICICI Bank,
          its affiliates, directors, representatives, employees and agents may
          suffer, pay or incur by reason of or in connection with arising out of
          the products/ services including the Facility including t that have
          been provided to me/us on my/ our specific request, including legal
          proceedings taken against ICICI Bank, its affiliates, directors,
          representatives, employees and agents.
          <br />
          <br />
          (i) I/We acknowledge that relying solely on my/our representations,
          warranties, undertakings and statements contained herein, ICICI Bank
          is agreeing to establish/continue its relationship with me/us and
          providing the Facility to me/us.
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              props.onHide();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // sending otp
  const sendOTPText = async (mobileNumber, option) => {
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        //Trigger AA Form Intermediate Event for OTP Receive
        if (option === "resend") {
          ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
        } else {
          formIntermediateEvent("receive", "otp");
        }
        notifySuccess("OTP has been sent to your mobile number.");
        setDistablebtn(true);
        setOtpsent(true);
        setTimerDisplay("inline");
        setTimer(30);
        // console.log("otp sent");
      } else {
        notifyWarn("Please Resend OTP.");
        setDistablebtn(true);
        setTimerDisplay("none");
        setOtpsent(false);
      }

      setMobileval(mobileNumber);
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify" };
    let currentError = { ...error };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      currentError["otp"] = "Invalid OTP entered.";
      notifyWarn("Invalid OTP");
      setOTP("");
      setErrors(currentError);
      // setResendBtn(true);
      return;
    }
    callLop(mobileVal);
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    inputs.otp = otpValue;
    // setResendBtn(false);
    setDistablebtn(true);
    setOtpBtn(true);
    setBtnDisable(false);
    setTimer(0);
    setOtpDisabled(true);
    hideDisplayBtn("initial");
    setOtpBtnText("Verified");
    //Trigger AA Form Intermediate Event for OTP Verify
    formIntermediateEvent("verified", "otp");
    notifySuccess("OTP Verified Successfully.");
  };

  const callLop = async (mobile) => {
    let prodText = "Pre-approved HL";

    let payload = {
      MobileNo: mobile,
      ProductCD: "",
    };
    let param = {};
    const response = await callLSQLapp(payload, "LOP", param);

    if (
      response.data.message.NewDataSet.Table.MSG !==
      "Mobile No. does not exist."
    ) {
      let table = response.data.message.NewDataSet.Table;
      let obj = table.find((o) => o.DestProd.includes(prodText));
      // console.log("offers", obj);
      if (obj) {
        // console.log("myobj", obj.DestProd);
        // console.log("myobj", obj.MaxOfferAmt);
        let offerAmt = obj.MaxOfferAmt.toLocaleString();
        console.log(offerAmt);
        // offersAlert(
        //   `Congratulations! We would like to inform you that you also have an offer of Pre-Approved Home Loan of ${offerAmt} with ICICI Bank.`
        // );
        offersAlert(
          `Congratulations! We would like to inform you that you also have an offer for instant sanction of ${offerAmt} with ICICI Bank`,
        );
      } else {
        console.log("no Pre-approved HL offers.");
      }
      setOffers(obj);
    } else {
      console.log("Mobile No. does not exist.");
    }
    return response;
  };

  useEffect(() => {
    let mobileVal = inputs["mobile"];
    if (mobileVal !== undefined) {
      if (mobileVal.length === 10) {
        if (mobileVal.length === 10 && otpsent === false) {
          sendOTPText(mobileVal);
        }

        if (mobileVal.length !== 10) {
          setOtpsent(false);
        }
        if (OTP.length === 6 && mobileVal.length === 10 && token === "") {
          // console.log("verifying num", { OTP, mobileVal });
          verifyOTPText(mobileVal, OTP);
        }
      }
    }
  }, [OTP, token, inputs["otp"], inputs["mobile"]]);

  // Format number with Indian commas
  const formatIndianNumber = (numStr) => {
    let num = numStr.replace(/,/g, "");
    let x = num.split(".");
    let lastThree = x[0].substring(x[0].length - 3);
    let otherNumbers = x[0].substring(0, x[0].length - 3);
    if (otherNumbers !== "") lastThree = "," + lastThree;
    let formatted =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return x.length > 1 ? formatted + "." + x[1] : formatted;
  };

  // Convert number to Indian-style words
  const numToWords = (n) => {
    const ones = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
    ];
    const teens = [
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    const tens = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
    let word = "";
    if (n >= 100) {
      word += ones[Math.floor(n / 100)] + " hundred ";
      n %= 100;
    }
    if (n >= 20) {
      word += tens[Math.floor(n / 10)] + " ";
      n %= 10;
    } else if (n >= 10) {
      word += teens[n - 10] + " ";
      return word.trim(); // Early return for teens
    }
    if (n > 0) {
      word += ones[n] + " ";
    }
    return word.trim();
  };

  const convertToWords = (numStr) => {
    const num = parseInt(numStr, 10);

    if (num === 0) return "Zero";
    if (num === 1000000000) return "One Hundred Crore";

    let words = "";

    // --- Conversion Logic ---
    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const remaining = num % 1000;

    if (crore > 0) {
      words += numToWords(crore) + " crore ";
    }
    if (lakh > 0) {
      words += numToWords(lakh) + " lakh ";
    }
    if (thousand > 0) {
      words += numToWords(thousand) + " thousand ";
    }
    if (remaining > 0) {
      words += numToWords(remaining);
    }

    // Capitalize the first letter and trim whitespace
    const finalWords = words.trim();
    return finalWords.charAt(0).toUpperCase() + finalWords.slice(1);
  };

  const handleFormStart = () => {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("HL NCA lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
  };

  let navigate = useNavigate();
  let formIsValid = true;

  const handleChange = async (event) => {
    handleFormStart();
    var name = event.target.name;
    var value = event.target.value;
    let currentError = { ...error };

    const fireDataLayerEvent = (eventName) => {
      if (!eventFired[name]) {
        DataLayerEvent(
          "",
          "",
          "custom_event",
          "home_loan_campaign",
          "nca",
          eventName,
          true,
        );
        setEventFired({ ...eventFired, [name]: true });
      }
    };

    //Fullname Validation
    if (name === "fullname") {
      fireDataLayerEvent("name_entered");
      value = value.replace(/[^A-Za-z\s]/gi, "");
      if (!value) {
        formIsValid = false;
        currentError["fullname"] = "Please enter your full name.";
      } else if (typeof value !== "undefined") {
        // let fullname = inputs.fullname.trim();
        if (!value.match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          currentError["fullname"] = "Please enter valid full name.";
        } else {
          currentError["fullname"] = "";
        }
      }
    }
    //PAN validation
    if (name === "pan") {
      fireDataLayerEvent("pan_number_entered");
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (!value) {
        formIsValid = false;
        currentError["pan"] = "Please enter a valid PAN.";
      } else if (typeof value !== "undefined") {
        if (!value.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
          formIsValid = false;
          currentError["pan"] = "Please enter a valid PAN.";
        } else {
          currentError["pan"] = "";
        }
      }
    }

    //Email Validation Start
    if (name === "email") {
      fireDataLayerEvent("email_address_entered");
      if (!value) {
        formIsValid = false;
        currentError["email"] = "Please enter your email.";
      } else if (typeof value !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
        );
        if (!pattern.test(value)) {
          formIsValid = false;
          currentError["email"] = "Please enter valid email.";
        } else {
          currentError["email"] = "";
        }
      }
    }

    //Mobile Number validation
    if (name === "mobile") {
      fireDataLayerEvent("mob_number_entered");
      if (!value) {
        formIsValid = false;
        currentError["mobile"] = "Please enter your mobile number.";
      } else if (typeof value !== "undefined") {
        value = value.replace(/^0+/, "");
        if (!value.match(/^[6-9]\d{9}$/)) {
          formIsValid = false;
          currentError["mobile"] = "Please enter valid mobile number.";
        } else {
          currentError["mobile"] = "";
        }
      }
    }
    //OTP Validation
    if (name === "otp") {
      fireDataLayerEvent("otp_entered");
      if (value.length === 6) {
        setOTP(value);
      }
      if (!value) {
        formIsValid = false;
        currentError["otp"] = "Please enter OTP.";
      } else if (typeof value !== "undefined" && value.length !== 6) {
        formIsValid = false;
        currentError["otp"] = "Please enter valid OTP.";
      } else {
        currentError["otp"] = "";
      }
    }
    //Check Field Validation
    if (name === "terms_chk") {
      //Trigger ctaClick event for checkbox field
      ctaClickEvent(
        `consent checkbox: ${event.target.checked}`,
        "lead form",
        "checkbox",
        0,
        "na",
      );
      if (!event.target.checked) {
        formIsValid = false;
        currentError["terms_chk"] = "Please accept the terms and conditions.";
      } else {
        currentError["terms_chk"] = "";
      }
    }

    //Pincode Validation
    if (name === "pincode") {
      fireDataLayerEvent("pincode_entered");
      let cityExists;
      setPIN(value);
      if (value.length === 6) {
        setCityname("Fetching...");
        //console.log("get city name here");
        let payload = { pincode: value };
        let param = { type: "pincode" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { uniqueArray, filteredCount } = response.data.message;
        // console.log("city", filteredCount > 0);
        if (filteredCount > 0) {
          cityExists = true;
          var CityNameIs = uniqueArray[0].District;
          console.log("cityName is", CityNameIs);
          setCityname(CityNameIs);
          setCitydefined(true);
          currentError["pincode"] = "";
        } else {
          cityExists = false;
          currentError["pincode"] = "Please enter valid pincode.";
          setCityname("City not found.");
          setCitydefined(false);
        }
      }
      inputs.pincode = value;
      inputs.CityName = CityNameIs;
      if (!value) {
        formIsValid = false;
        currentError["pincode"] = "Please enter pincode.";
      } else if (value && !value.match(/^[1-9][0-9]{5}$/)) {
        formIsValid = false;
        currentError["pincode"] = "Please enter valid pincode.";
      } else if (value && value.match(/^[1-9][0-9]{5}$/) && !cityExists) {
        formIsValid = false;
        currentError["pincode"] = "Please enter valid pincode.";
      } else {
        currentError["pincode"] = "";
      }
    }

    if (name === "homeLoanAmountRequired") {
      fireDataLayerEvent("homeLoanAmountRequired");
      // Only keep digits
      // value = value.replace(/\D/g, "");
      if (!value) {
        formIsValid = false;
        currentError["homeLoanAmountRequired"] =
          "Please select home loan amount required.";
      } else {
        currentError["homeLoanAmountRequired"] = ""; // Clear error
      }

      // else {
      //   inputs.amountInWords = convertToWords(value);
      //   value = formatIndianNumber(value);
      //   currentError["homeLoanAmountRequired"] = "";
      // }
    }

    setErrors(currentError);
    setSpaceTwo(true);
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const currentErrors = { ...error };
    //Personal details validations
    //PAN validation
    if (!inputs["pan"]) {
      formIsValid = false;
      currentErrors["pan"] = "Please enter a valid PAN.";
    }
    if (typeof inputs["pan"] !== "undefined") {
      if (!inputs["pan"].match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
        formIsValid = false;
        currentErrors["pan"] = "Please enter a valid PAN.";
      }
    }
    //Fullname Validation Start
    if (!inputs["fullname"]) {
      formIsValid = false;
      currentErrors["fullname"] = "Please enter your fullname.";
    }

    if (typeof inputs["fullname"] !== "undefined") {
      // let fullname = inputs.fullname.trim();
      if (!inputs["fullname"].match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        currentErrors["fullname"] = "Please enter valid full name.";
      }
    }

    //Email Validation Start
    if (!inputs["email"]) {
      formIsValid = false;
      currentErrors["email"] = "Please enter your email.";
    }

    if (typeof inputs["email"] !== "undefined") {
      //regular expression for email validation
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!pattern.test(inputs["email"])) {
        formIsValid = false;
        currentErrors["email"] = "Please enter valid email.";
      }
    }

    if (!inputs["mobile"]) {
      formIsValid = false;
      currentErrors["mobile"] = "Please enter your mobile number.";
    }

    if (typeof inputs["mobile"] !== "undefined") {
      inputs["mobile"] = inputs["mobile"].replace(/^0+/, "");
      if (!inputs["mobile"].match(/^[6-9]\d{9}$/)) {
        formIsValid = false;
        currentErrors["mobile"] = "Please enter valid mobile number.";
      }
    }

    if (typeof inputs["mobile"] !== "undefined") {
      inputs["mobile"] = inputs["mobile"].replace(/^0+/, "");
      if (!inputs["mobile"].match(/^[6-9]\d{9}$/)) {
        formIsValid = false;
        currentErrors["mobile"] = "Please enter valid mobile number.";
      }
    }

    if (!inputs["otp"]) {
      formIsValid = false;
      currentErrors["otp"] = "Please enter OTP.";
    }

    if (typeof inputs["otp"] !== "undefined" && inputs["otp"].length !== 6) {
      formIsValid = false;
      currentErrors["otp"] = "Please enter valid OTP.";
    }

    if (!checked) {
      formIsValid = false;
      currentErrors["terms_chk"] = "Please accept the terms and conditions.";
    }

    if (!inputs["pincode"] && !citydefined) {
      formIsValid = false;
      currentErrors["pincode"] = "Please enter pincode.";
    }

    if (inputs["pincode"] && !inputs["pincode"].match(/^[1-9][0-9]{5}$/)) {
      if (!citydefined) {
        formIsValid = false;
        currentErrors["pincode"] = "Please enter valid pincode.";
      }
    }

    if (!inputs["homeLoanAmountRequired"]) {
      formIsValid = false;
      currentErrors["homeLoanAmountRequired"] =
        "Please select home loan amount required.";
    }

    setErrors(currentErrors);
    setSpaceTwo(true);

    if (formIsValid) {
      setSpaceTwo(false);
      setApplyBtnDisable(true);
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        if (key !== "campaign_code") {
          inputs[key] = value;
        }
      }
      if (utmParamsObj.campaign_code) {
        inputs.CampaignId = "833240";
        inputs.ApiProductName = "NPA HL";
      } else {
        inputs.CampaignId = "819306";
        inputs.ApiProductName = "HL BAU";
      }
      inputs.UserName = "homeloan";
      inputs.Password = "homeloan";
      inputs.ApiCompanyName = "internal";
      inputs.ParentProduct = "Home Loan";
      inputs.ModeOfLead = "landing-page";
      if (checked) {
        inputs.DND = "Yes";
        inputs.terms_chk = true;
      } else {
        inputs.DND = "No";
        inputs.terms_chk = false;
      }
      inputs.DeviceType = "";
      inputs.CostOfProperty = "";
      inputs.token = token;

      const eligibilityObject = getEligibility(inputs, "HL");
      console.log("eligiblity", eligibilityObject);
      inputs.IsEligible = eligibilityObject.eligible;
      inputs.EligibilityReason = eligibilityObject.reason;
      inputs.CompleteUrl = window.location.href;
      inputs.User_Agent = navigator.userAgent;
      await setValuesInLocalStorange(inputs["email"], inputs["mobile"]);
      let payload = {
        mobile: inputs.mobile,
        otp: inputs.otp,
        formdata: getLsqLeadBody(inputs),
      };
      console.log("Lead Create Payload", payload);

      //Encrypt Payload
      const encryptedPayload = await encryptBody(payload);
      // console.log("Lead Create encrypted Payload", encryptedPayload);

      let param = {};
      let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        console.log("leadID", leadid);
        //Trigger AA formSuccess event
        formSuccessEvent(
          "HL NCA lead form",
          { otp: inputs.otp, pincode: inputs.pincode, city: inputs.CityName },
          "lead generation",
          "thank you",
          true,
        );
        navigate(`/thankyou?id=${leadid}`);
        // if (inputs.homeLoanAmountRequired === "Less than 10 lakhs") {
        //   navigate(`/thankyou-not-eligible?id=${leadid}`);
        // } else {
        //   navigate(`/thankyou?id=${leadid}`);
        // }

        // let criffPayload = {
        //   Current: {
        //     ProspectID: leadid,
        //     FirstName: inputs.fullname,
        //     LastName: "",
        //     mx_Pincode: inputs.pincode,
        //     mx_Date_of_Birth: "",
        //     mx_PAN: inputs.pan,
        //     mx_City: inputs.CityName,
        //     Phone: "",
        //     Mobile: inputs.mobile.slice(-10),
        //     EmailAddress: inputs.email,
        //     LandingPage: inputs.CompleteUrl,
        //   },
        // };
        // // console.log("criff payload: ", criffPayload);
        // const encryptedCriffPayload = await encryptBody(criffPayload);
        // // console.log("encrypted criff payload: ", encryptedCriffPayload);

        // const criffResp = await callLSQLapp(encryptedCriffPayload, "CRIF", {
        //   requestFrom: "HL_LP",
        // });
        // console.log("criff resp: ", criffResp);

        // const cibilScore = criffResp?.data?.message?.cibilScore;

        // if (cibilScore && [87, 77, 65].includes(Number(cibilScore))) {
        //   // console.log("CIBIL score exists and is one of 87, 77, or 65");
        //   navigate(`/thankyou-not-eligible?id=${leadid}`);
        // } else {
        //   navigate(`/thankyou?id=${leadid}`);
        // }
      } else {
        setApplyBtnDisable(false);
        //Trigger AA formSubmissionFail event
        formSubmissionFailEvent();
        console.log("lead not created.");
      }
    } else {
      //Trigger AA formFieldError event
      formFieldErrorEvent(currentErrors);
    }
  };

  return (
    <>
      <article
        className={`banner_section position-relative ${
          space ? "m_update" : null
        } ${spaceTwo ? "m_update_two" : null}`}
      >
        <div className="banner_img">
          <picture>
            {/* <source rel="preload"  media="(max-width: 767px)" srcset="dist/img/banner_mobile.webp" type="image/webp"> */}
            <source
              rel="preload"
              media="(max-width:767.5px)"
              srcSet="dist/img/hl_banner_mob.jpg"
              alt="ICICI Bank Home Loan Banner"
              width={767}
              height={241}
            />
            {/* <source rel="preload"  srcset="dist/img/banner_mobile.webp" type="image/webp"> */}
            <img
              rel="preload"
              src="dist/img/hl_banner_desk.jpg"
              alt="Banner img"
              width={1920}
              height={764}
              className="img-fluid d-none d-md-block"
            />
            <img
              rel="preload"
              src="dist/img/hl_banner_mob.jpg"
              alt="Banner img"
              width={1920}
              height={764}
              className="img-fluid d-block d-md-none"
            />
          </picture>
        </div>
        {/* <div className="bannerHeading">
          <p>Avail attractive interest rate on our Home Loan</p>
        </div> */}
        {/* <ul> */}
        {/* <li>
            <div className="banner_content_img">
              <img
                src="dist/img/home_interest_rate.webp"
                alt="ICICI Bank"
                className="img-fluid"
              />
            </div>
            <h2>
              Attractive
              <br /> Interest Rates
            </h2>
          </li> */}
        {/* <li>
          <div className="banner_content_img">
            <img
              src="dist/img/hassle_free.webp"
              alt="ICICI Bank"
              className="img-fluid"
            />
          </div>
          <h2>
            Hassle Free
            <br /> Documentation
          </h2>
        </li> */}
        {/* <li>
            <div className="banner_content_img">
              <img
                src="dist/img/home_digital_sanction.webp"
                alt="ICICI Bank"
                className="img-fluid"
              />
            </div>
            <h2>
              Digital
              <br /> Sanction
            </h2>
          </li> */}
        {/* <li>
            <div className="banner_content_img">
              <img
                src="dist/img/disbursement.webp"
                alt="ICICI Bank"
                className="img-fluid"
              />
            </div>
            <h2>
              Quick
              <br /> Disbursement
            </h2>
          </li> */}
        {/* </ul> */}
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-12">
              <div className="form_wrap" id="apply_gold_loan">
                <div className="form_heading">
                  <h4>Apply now to get an online sanction</h4>
                </div>
                <form name="contactForm" method="post" onSubmit={handleSubmit}>
                  {personalShow === true && (
                    <section className="personal-details">
                      <div className="col-12 my-2">
                        <input
                          type="text"
                          name="fullname"
                          placeholder="Name"
                          id="name"
                          value={
                            inputs.fullname
                              ? inputs.fullname.replace(/[^a-z ]/gi, "")
                              : ""
                          }
                          onChange={handleChange}
                        />
                      </div>
                      <span className="error" id="day_error">
                        {error.fullname}
                      </span>
                      <div className="form-group my-2">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Email"
                          onChange={handleChange}
                        />
                      </div>
                      <span className="error" id="day_error">
                        {error.email}
                      </span>
                      <div className="my-2">
                        <span className="position-relative">
                          <div className="number-span">+91</div>
                          <input
                            type="number"
                            name="mobile"
                            placeholder="Mobile Number"
                            pattern="\d{10}"
                            id="mobile_number"
                            style={{ textAlign: "left" }}
                            defaultValue={inputs.mobile}
                            value={
                              inputs.mobile > 0
                                ? inputs.mobile.replace(/^[0-5]+/, "")
                                : ""
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(0, 10))
                            }
                            onChange={handleChange}
                            disabled={disableBtn}
                          />
                          {otpsent && timer <= 0 ? (
                            <button
                              type="button"
                              className="btn"
                              id="resendBtn"
                              onClick={() => sendOTPText(mobileVal, "resend")}
                              style={{ display: resendBtnDisplay }}
                              disabled={otpDisabled}
                            >
                              {otpBtnText}
                            </button>
                          ) : (
                            <span
                              className="Timer"
                              id="timer"
                              style={{ display: timerDisplay }}
                            >
                              {" "}
                              00:
                              {timer.toString().length < 2
                                ? timer.toString().padStart(2, "00")
                                : timer}
                            </span>
                          )}
                        </span>
                      </div>
                      <span className="error" id="day_error">
                        {error.mobile}
                      </span>
                      <div className="my-2">
                        <input
                          type="number"
                          name="otp"
                          placeholder="OTP"
                          id="otp"
                          onInput={(e) =>
                            (e.target.value = e.target.value.slice(0, 6))
                          }
                          onChange={handleChange}
                          disabled={otpdisableBtn}
                        />
                      </div>
                      <span className="error" id="day_error">
                        {error.otp}
                      </span>
                      <div className="my-2">
                        <input
                          type="text"
                          name="pan"
                          placeholder="PAN Card Number"
                          id="pan"
                          value={inputs.pan ? inputs.pan : ""}
                          onChange={handleChange}
                          onInput={(e) =>
                            (e.target.value = e.target.value.slice(0, 10))
                          }
                        />
                      </div>
                      <span className="error" id="day_error">
                        {error.pan}
                      </span>
                      {/* <div className="my-2">
                        <input
                          type="text"
                          name="homeLoanAmountRequired"
                          placeholder="Home Loan Amount Required"
                          value={inputs.homeLoanAmountRequired}
                          onChange={handleChange}
                        />
                      </div>
                      {error.homeLoanAmountRequired ? (
                        <span className="error">
                          {error.homeLoanAmountRequired}
                        </span>
                      ) : (
                        <span className="noError">{inputs.amountInWords}</span>
                      )} */}
                      <div className="my-2">
                        <select
                          name="homeLoanAmountRequired"
                          onChange={handleChange}
                          value={inputs.homeLoanAmountRequired || ""}
                        >
                          <option value="" disabled hidden>
                            Home Loan Amount Required
                          </option>
                          <option value="Less than 10 lakhs">
                            Less than 10 lakhs
                          </option>
                          <option value="More than 10 lakhs">
                            More than 10 lakhs
                          </option>
                          {/* <option value="20 Lacs to 50 Lacs">
                            20 Lacs to 50 Lacs
                          </option>
                          <option value="Less than 20 Lacs">
                            Less than 20 Lacs
                          </option>
                          <option disabled>
                            Loan requirement below 20 lakhs is not eligible for
                            digital application{" "}
                          </option> */}
                        </select>
                      </div>
                      <span className="error" id="day_error">
                        {error.homeLoanAmountRequired}
                      </span>

                      {/* <div className="my-2">
                        <select name="propertyIdentified" onChange={handleChange} value={inputs.propertyIdentified || ''}>
                          <option value="" disabled hidden>Property Identified?</option>
                          <option value="Yet to be identified">Yet to be identified</option>
                          <option value="Identified - Under Construction">Identified - Under Construction</option>
                          <option value="Identified – Construction completed">Identified – Construction completed</option>
                        </select>
                      </div>
                      <span className="error" id="day_error">
                        {error.propertyIdentified}
                      </span> */}

                      <section className="professional-details">
                        <div className="salaried">
                          <div className="location_details">
                            <div
                              className="location_detail"
                              id="sal_location_detail"
                            >
                              <div className="autocomplete">
                                <input
                                  className="cityList city_fetch"
                                  type="number"
                                  placeholder="Property PIN Code"
                                  id="sal_pincode"
                                  name="pincode"
                                  onInput={(e) =>
                                    (e.target.value = e.target.value.slice(
                                      0,
                                      6,
                                    ))
                                  }
                                  value={
                                    inputs.sal_pincode > 0
                                      ? inputs.sal_pincode.replace(/^0+/, "")
                                      : inputs.sal_pincode
                                  }
                                  onChange={handleChange}
                                />
                              </div>
                              <span className="error" id="day_error">
                                {error.pincode}
                              </span>

                              <div>
                                <input
                                  className="cityList city_fetch"
                                  type="text"
                                  placeholder="City (Auto fetch)"
                                  id="sal_pincode"
                                  name=""
                                  autoComplete="off"
                                  value={cityName}
                                  disabled
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <div className="checkbox row">
                        <div className="col-1 check-input">
                          <input
                            type="checkbox"
                            name="terms_chk"
                            defaultChecked={checked}
                            onClick={() => setChecked(!checked)}
                            id="terms_chk"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-11 p-0 ">
                          <label htmlFor="terms_chk">
                            I agree to be bound by these{" "}
                            <a
                              target="_blank"
                              href="https://www.icicibank.com/terms-condition?_ga=2.59170351.365826006.1680849363-894239963.1678362457"
                              onClick={() => {
                                handleFormStart();
                                ctaClickEvent(
                                  "terms & conditions",
                                  "lead form",
                                  "text link",
                                  0,
                                  "https://www.icicibank.com/terms-condition?_ga=2.59170351.365826006.1680849363-894239963.1678362457",
                                );
                              }}
                              onContextMenu={() => {
                                handleFormStart();
                                ctaClickEvent(
                                  "terms & conditions",
                                  "lead form",
                                  "text link",
                                  0,
                                  "https://www.icicibank.com/terms-condition?_ga=2.59170351.365826006.1680849363-894239963.1678362457",
                                );
                              }}
                            >
                              Terms & Conditions
                            </a>{" "}
                            and{" "}
                            <Button
                              variant="primary"
                              className="MIT"
                              onClick={() => {
                                setModalShow(true);
                                handleFormStart();
                                ctaClickEvent(
                                  "open: Most Important Terms & Conditions",
                                  "lead form",
                                  "text link",
                                  0,
                                  "na",
                                );
                              }}
                              // style={{ fontSize: "12px" }}
                            >
                              Most Important Terms & Conditions
                            </Button>
                            <MyVerticallyCenteredModal
                              show={modalShow}
                              onHide={() => {
                                setModalShow(false);
                                ctaClickEvent(
                                  "close: Most Important Terms & Conditions",
                                  "popup",
                                  "icon or button",
                                  0,
                                  "na",
                                );
                              }}
                            />{" "}
                            prescribed by ICICI Bank Limited. I permit ICICI
                            Bank Limited to share my contact details with ICICI
                            Home Finance Company. Further, I specifically permit
                            representatives from ICICI Bank Limited & ICICI Home
                            Finance Company to reach out to me through my
                            registered e-mail, phone, SMS, WhatsApp messaging,
                            or any other electronic mode or other messaging or
                            social media platforms in relation to my home loan
                            application.
                          </label>
                        </div>
                        <span className="error" id="day_error">
                          {error.terms_chk}
                        </span>
                      </div>
                      <div>
                        <input
                          type="submit"
                          name="form-submitF"
                          value="Apply Now"
                          className="next_btn"
                          id="nxt_btnsubmit"
                          onChange={handleChange}
                          onClick={() => {
                            handleFormStart();
                            if (!eventFired["applyNow"]) {
                              DataLayerEvent(
                                "",
                                "",
                                "custom_event",
                                "home_loan_campaign",
                                "nca",
                                "apply_now_clicked",
                                true,
                              );
                              setEventFired({ ...eventFired, applyNow: true });
                            }
                          }}
                          disabled={disableApplyBtn}
                        />
                      </div>
                    </section>
                  )}
                </form>
                <ToastContainer />
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default Form;
